import React, { Component } from "react";
import { Table, Dropdown } from "react-bootstrap";
import { utcToReportDate, getTimeSpanToNow } from "../../utils/dateConvert";
import { rounding, getFriendlyHeading } from "../../utils/math";
import imag from "../../static/images/truck.png";
import Location from '../commoncomponents/location';
import ShowIButtonName from "../commoncomponents/showIButtonName";

class RealTimeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: Date.now(),
    };
    this.realTime = 1;
  }

  componentDidMount() {
    // Trigger an update once per second
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.time !== nextState.time;
  }

  handleNullCheck = (value, index) => {
    if (this.props.realTimeData[index].lastMessage && this.props.realTimeData[index].lastMessage.gPRMC) {
      return this.props.realTimeData[index].lastMessage.gPRMC[value];
    } else {
      return null;
    }
  };

  getLocation = (data) => {
    var lastMessage = data.lastMessage;
    if (!lastMessage) return null;

    var gPRMC = lastMessage.gPRMC;
    if (!gPRMC) return null;

    return {
      assetId: lastMessage.assetID,
      created: utcToReportDate(lastMessage.created),
      address: lastMessage.location,
      lat: gPRMC.latitude,
      lng: gPRMC.longitude,
      speed: gPRMC.speed,
      odometer: lastMessage.odometer,
      name: data.assetName,
      tempA: lastMessage.sensorAValue,
      tempB: lastMessage.sensorBValue,
      fridge: this.handleFridge(data),
      gprs: lastMessage.gprsOnline,
      heading: gPRMC.heading,
      parking: lastMessage.iO3,
      trip: lastMessage.tripCount,
      duress: data.lastDuress || "",
      volt: lastMessage.deviceVolts,
      satelite: lastMessage.satellites,
      lastUpdated: lastMessage.received,
      friendlyName: data.friendlyName,
      lastDuress: data.lastDuress || "",
      lastPowerCut: data.lastPowerCut || "",
      lastStatusChange: data.lastStatusChange || "",
    };
  };

  handleFridge = (data) => {
    if (!data.lastMessage) return null;
    return data.lastMessage.iO1 == 1 ? "On" : "Off";
  };

  handleTruck = (data, index) => {
    let response = this.getLocation(data, index);
    if (response != null) {
      this.props.onTruckSelection(response);
    }
  };

  compare = (a, b) => {
    if (a.assetName < b.assetName) return -1;
    if (a.assetName > b.assetName) return 1;
    return 0;
  };

  render() {
    let { realTimeData } = this.props;
    realTimeData.sort(this.compare);

    return (
      <Table striped className="realTimeHeight">
        <thead>
          <tr>
            <th></th>
            <th>Received</th>
            <th>Friendly Name</th>
            <th>Name</th>
            <th>Location</th>
            <th>GPS</th>
            <th>Engine</th>
            <th>Speed</th>
            <th>Direction</th>
            <th>Fridge</th>
            <th>TempA</th>
            <th>TempB</th>
            <th>Status</th>
            <th>Odometer</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {realTimeData.map((data, index) => {
            if (data.status !== "Disabled") {
              let lastMessage = data.lastMessage || {};
              let gPRMC = lastMessage.gPRMC || {};

              return (
                <tr key={index}>
                  <td onClick={() => this.handleTruck(data, index)} title="Click to center on map" className="truck-icon">
                    <img alt="truck" src={imag} style={{ width: "20px", height: "20px" }}></img>
                  </td>

                  <td title={`Received: ${utcToReportDate(lastMessage.created)}, Log:${lastMessage.messageID}`}>
                    {utcToReportDate(lastMessage.created)}
                  </td>

                  <td>{data.friendlyName || ""}</td>

                  <td>
                    <a href={`/Track?assetId=${data.assetId}&assetName=${data.assetName}`} target="_blank" rel="noreferrer">
                      {data.assetName}
                    </a>
                    <br />
                    <ShowIButtonName ibuttonId={data.ibuttonId} serialno={data.serialno} iButtonName={data.iButtonName} />
                  </td>

                  <td>
                    <Location realTime={this.realTime} address={lastMessage.location} lat={gPRMC.latitude} lng={gPRMC.longitude} />
                  </td>

                  <td>
                    {lastMessage.gprsOnline == 1 ? (
                      <i className="fa fa-globe text-normal" style={{ color: "green" }} title="Lock" />
                    ) : (
                      <i className="fa fa-globe text-danger" title="No Lock" />
                    )}
                  </td>

                  <td>
                    {lastMessage.iO3 == 1 ? (
                      <p>
                        <span className="engine-driving" title="Driving">
                          D
                        </span>
                        &nbsp;&nbsp;
                        {getTimeSpanToNow(data.lastStatusChange)}
                      </p>
                    ) : (
                      <p>
                        <span className="engine-park" title="Parked">
                          P
                        </span>
                        &nbsp;&nbsp;
                        {getTimeSpanToNow(data.lastStatusChange)}
                      </p>
                    )}
                  </td>

                  <td>{rounding(gPRMC.speed)}</td>

                  <td>{getFriendlyHeading(gPRMC.heading)}</td>

                  <td>{this.handleFridge(data)}</td>
                  <td>{lastMessage.sensorAValue}</td>
                  <td>{lastMessage.sensorBValue}</td>
                  <td>{data.statusString}</td>

                  <td>{lastMessage.odometer}</td>

                  <td>
                    <Dropdown>
                      <Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
                        Reports
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href={`/Rpt-MVTL?assetId=${data.assetId}&assetName=${data.assetName}`} target="_blank">
                          MVTL
                        </Dropdown.Item>
                        <Dropdown.Item href={`/Rpt-Visit?assetId=${data.assetId}&assetName=${data.assetName}`} target="_blank">
                          Visit
                        </Dropdown.Item>
                        <Dropdown.Item href={`/Temperature?assetId=${data.assetId}&assetName=${data.assetName}`} target="_blank">
                          Temperature
                        </Dropdown.Item>
                        <Dropdown.Item href={`/track?assetId=${data.assetId}&assetName=${data.assetName}`} target="_blank">
                          Track
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            }

            return null;
          })}
        </tbody>
      </Table>
    );
  }
}

export default RealTimeTable;
